// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SliderOfferSection_cardContainer__3IRHx","sliderContainer":"SliderOfferSection_sliderContainer__22hE6","nextButton":"SliderOfferSection_nextButton__HsITf"};